
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { option_type, record_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class WebPushConfiguration extends Record {
    constructor(ApiKey, ProjectId, MessagingSenderId, AppId, VapidKey) {
        super();
        this.ApiKey = ApiKey;
        this.ProjectId = ProjectId;
        this.MessagingSenderId = MessagingSenderId;
        this.AppId = AppId;
        this.VapidKey = VapidKey;
    }
}

export function WebPushConfiguration_$reflection() {
    return record_type("Shared.WebPush.WebPushConfiguration", [], WebPushConfiguration, () => [["ApiKey", string_type], ["ProjectId", string_type], ["MessagingSenderId", string_type], ["AppId", string_type], ["VapidKey", string_type]]);
}

export class WebPushConfigurationDto extends Record {
    constructor(Configuration) {
        super();
        this.Configuration = Configuration;
    }
}

export function WebPushConfigurationDto_$reflection() {
    return record_type("Shared.WebPush.WebPushConfigurationDto", [], WebPushConfigurationDto, () => [["Configuration", option_type(WebPushConfiguration_$reflection())]]);
}

export class WebDeviceTokenDto extends Record {
    constructor(Token) {
        super();
        this.Token = Token;
    }
}

export function WebDeviceTokenDto_$reflection() {
    return record_type("Shared.WebPush.WebDeviceTokenDto", [], WebDeviceTokenDto, () => [["Token", string_type]]);
}

